import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthViewModel } from '../viewmodels/AuthViewModel';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const location = useLocation();
  const authViewModel = new AuthViewModel();
  
  // Check authentication status
  authViewModel.checkAuthStatus();
  const isAuthenticated = authViewModel.isAuthenticated;

  if (!isAuthenticated) {
    // Redirect to login page, saving the attempted location
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};
